import {
  acquireWhatIfsLoadingSpinner,
  releaseWhatIfsLoadingSpinner,
  setErrors,
  updateWhatIfsData,
} from '../../WhatIfsActions';

export const storeTheOptimizationResults = (
  dispatch,
  clientId,
  goalId,
  whatIfType,
  backendObject,
) => {
  dispatch(updateWhatIfsData(clientId, goalId, whatIfType, {
    WhatIf: {
      SocialSecurityStartAgePrincipal: backendObject.SocialSecurityPrincipalStartAge,
      SocialSecurityStartAgeSpouse: backendObject.SocialSecuritySpouseStartAge,
      SocialSecurityUseSpousalBenefit: backendObject.SocialSecurityUseSpousalBenefit,
      SocialSecurityFileForSurvivorBenefits: backendObject.SocialSecurityUseSurvivorBenefits,
    },
  }));
};

export const optimizeSocialSecurity = (mode, clientId, fpId, goalId, whatIfType) => (dispatch) => {
  const { ADV } = window;
  acquireWhatIfsLoadingSpinner(clientId, dispatch)();
  ADV.util
    .request({
      type: 'POST',
      uri: 'Consumer/OptimizeSocialSecurity/GetOptimalSocialSecuritySolution',
      urlParams: {
        clientId,
        fpId,
        mode,
        goalId,
      },
      showSpinner: false,
    })
    .then((response) => {
      if (response.success) {
        dispatch(setErrors(clientId, []));
        storeTheOptimizationResults(
          dispatch,
          clientId,
          goalId,
          whatIfType,
          response.payload.viewData,
        );
      } else {
        dispatch(setErrors(clientId, response.errors));
      }
    })
    .catch(() => {
      dispatch(setErrors(clientId, [ADV.settings.MsgLib.generic_error]));
    })
    .then(
      releaseWhatIfsLoadingSpinner(clientId, dispatch),
      releaseWhatIfsLoadingSpinner(clientId, dispatch),
    );
};

export const optimizeSocialSecurityMock = (
  mode,
  clientId,
  fpId,
  goalId,
  whatIfType,
) => (dispatch) => {
  acquireWhatIfsLoadingSpinner(clientId, dispatch)();
  setTimeout(() => {
    dispatch(setErrors(clientId, []));
    storeTheOptimizationResults(dispatch, clientId, goalId, whatIfType, {
      SocialSecurityPrincipalStartAge: 77,
      SocialSecuritySpouseStartAge: 89,
      SocialSecurityUseSpousalBenefit: true,
      SocialSecurityUseSurvivorBenefits: false,
    });
    releaseWhatIfsLoadingSpinner(clientId, dispatch)();
  }, 500);
};
